import React, { useState, useEffect } from 'react';
import { HiArrowDown } from "react-icons/hi";
import { scrollToAboutMe, scrollToCareer, scrollToProjects, scrollToSkills } from '../utils/scroll';

const LINKSTYLE = "text-sm lg:text-md hover:underline decoration-solid cursor-pointer ";

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const scrollToBanner = () =>{
    const bannerSection = document.getElementById('banner');
    bannerSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  useEffect(() => {
    const handleScroll = () => {
      const navbarHeight = document.querySelector('section').offsetHeight;
      if (window.scrollY >= navbarHeight) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <header className='flex w-full h-screen justify-center'>
      <div className={`w-full fixed top-0 z-50 ${isScrolled ? 'bg-white text-black shadow-navbar ' : 'text-gray-200'}`}>
        <section className={`w-5/6 mx-auto `}>
          <div className={`flex justify-between items-center  ${isScrolled ? '': 'border-b border-gray-300'}  p-2 h-16 mx-2`}>
            <p className='flex self-baseline items-center text-4xl mr-5 cursor-pointer' onClick={scrollToBanner}>
              <h1 className='hidden md:block font-home-icon '>Gyuyoung</h1>
            </p>
            <nav className='flex text-4xl gap-6 truncate overflow-scroll font-semibold '>
              <p className={LINKSTYLE} onClick={scrollToAboutMe}>ABOUT ME</p>
              <p className={LINKSTYLE} onClick={scrollToCareer}>CAREER</p>
              <p className={LINKSTYLE} onClick={scrollToProjects}>PROJECTS</p>
              <p className={LINKSTYLE} onClick={scrollToSkills}>SKILLS</p>
            </nav>
          </div>
        </section>
      </div>
      <div id="banner" className='bg-img w-full h-auto relative'>
        <div className="absolute inset-0 bg-black opacity-50"></div>
        <img className="w-full h-full object-cover object-center z-10" src="/images/1.jpg" alt="laptop pic" />
        <div className='text-center text-5xl sm:text-6xl font-banner-font text-gray-100 absolute inset-0 flex flex-col justify-center items-center z-20'>
          <p>- 이규영 -</p>
          <p className='mt-5'>웹 개발자 포트폴리오</p>
          <hr className='w-24 mt-5 border-2 border-brand'/>
          <div className='shape-icon-parent'>
          <img className="shape-icon absolute bottom-56 -right-24" src="https://www.demimaisons.be/themes/demimaisons/assets/images/shape-sud.png" alt="leaf icon" />
        </div>
        <div className='text-xl mt-7 font-home-icon relative '>
          <p className='mb-2'>안녕하세요</p>
          <p className='mb-2'>고객의 니즈를 현실로 구현하는</p>
          <p className='mb-2'>프론트엔드 개발자 이규영입니다.</p>
        </div>
        <button onClick={scrollToAboutMe} className='text-xl hover:brightness-110 flex w-auto h-auto bg-button absolute mb-32 bottom-0 p-6 rounded-full'>
          <p>더 알아보기</p>
          <HiArrowDown className="text-2xl down-arrow"/>
        </button>
        </div>
      </div>
    </header>
  );
}
